module.exports = __webpack_public_path__ + "img/sad.001cee56.svg";